import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportAval extends GuiListGeneric {
    constructor() {
        super("Aval");
    }
}
